module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "echarts"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.9.9.5@vue-loader/lib/template-compiler.js?id=data-v-66667b7f!./~/.9.9.5@vue-loader/lib/selector.js?type=template&index=0!./~/.2.2.0@vue-echarts/components/ECharts.vue
// module id = 189
// module chunks = 2